import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Banner = () => {
  return (
    <>
      <div
        id="home"
        className="banner"
        style={{
          backgroundImage: `url('./images/banner.jpg')`,
        }}
      ></div>
      <Container>
        <Row>
          <Col className="banner-text d-flex justify-content-center">
            <h1>
              <span>
                What <span className="fw-bolder banner-text-if">IF</span>
              </span>
            </h1>
            <h2>You didn't have interest on your mortgage?</h2>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Banner;
